import { validateWithdraw, withdrawalValidationIssueToMessage } from '@/domain/market-validators/validateWithdraw'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { UseFormReturn } from 'react-hook-form'
import { AssetInputSchema } from '@/features/dialogs/common/logic/form'
import { FormFieldsForDialog } from '@/features/dialogs/common/types'
import { NormalizedUnitNumber, Percentage } from '@/domain/types/NumericValues'
import { Token } from '@/domain/types/Token'
import BigNumber from 'bignumber.js'

export interface GetWithdrawDialogFormValidatorOptions {
  deposited: NormalizedUnitNumber
  availableLiquidity: NormalizedUnitNumber
}

export function getWithdrawDialogFormValidator({
  deposited,
  availableLiquidity,
}: GetWithdrawDialogFormValidatorOptions) {
  return AssetInputSchema.superRefine((field, ctx) => {
    const value = NormalizedUnitNumber(field.value === '' ? '0' : field.value)

    const validationIssue = validateWithdraw({
      value,
      asset: {
        status: 'active',
        unborrowedLiquidity: NormalizedUnitNumber(0),
        availableLiquidity,
      },
      user: {
        deposited,
        liquidationThreshold: Percentage(0.8),
        ltvAfterWithdrawal: Percentage(0.5),
        eModeState: { enabled: false },
      },
      isIsolated: true,
    })

    if (validationIssue) {
      ctx.addIssue({
        code: 'custom',
        message: withdrawalValidationIssueToMessage[validationIssue],
        path: ['value'],
      })
    }
  })
}

export function getFormFieldsForWithdrawDialog(
  form: UseFormReturn<AssetInputSchema>,
  token: Token,
  balance: NormalizedUnitNumber,
  available: NormalizedUnitNumber,
): FormFieldsForDialog {
  const changeAsset = (newSymbol: TokenSymbol): void => {
    form.setValue('symbol', newSymbol)
    form.setValue('value', '')
    form.clearErrors()
  }

  const { value } = form.getValues()

  return {
    selectedAsset: {
      value,
      token,
      balance: NormalizedUnitNumber(balance.dp(6, BigNumber.ROUND_DOWN)),
    },
    maxSelectedFieldName: 'isMaxSelected',
    changeAsset,
    maxValue: NormalizedUnitNumber(available.dp(6, BigNumber.ROUND_DOWN)),
    displayBalance: NormalizedUnitNumber(available.dp(6, BigNumber.ROUND_DOWN)),
  }
}
